/**
 * 资金管理路由
 * @Description: 资金管理模块路由及完整子路由
 *
 * @Author: JZT.lmy
 * @Date: 2018-10-12 08:57:14
 * @Last Modified by: JZT.lmy
 * @Last Modified time: 2018-11-12 15:42:06
 */
export default [
    {
        path: "/paymentCenter/trxRecords",
        name: "交易记录",
        component: () => import("@/pages/paymentCenter/trxRecords/Index"),
        icon: "none",
        meta: {
            comName: "trxRecords",
            needRefresh: true
        }
    },
    {
        path: "/paymentCenter/accountOverview",
        name: "账户总览(招行)",
        component: () => import("@/pages/paymentCenter/accountOverview/accountOverviewList"),
        icon: "none",
        meta: {
            comName: "accountOverviewList",
            needRefresh: true
        }
    },
    {
        path: "/paymentCenter/accountOverviewOrdinary",
        name: "账户总览",
        component: () => import("@/pages/paymentCenter/accountOverview/accountOverviewListOrdinary"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "accountOverviewListOrdinary",
            needRefresh: true
        }
    },
    {
        path: "/paymentCenter/withdraw",
        name: "订单提现(招行)",
        component: () => import("@/pages/paymentCenter/withdraw/withdraw"),
        icon: "none",
        meta: {
            comName: "withdrawList",
            needRefresh: true
        }
    },
    {
        path: "/paymentCenter/withdrawOrdinary",
        name: "订单提现",
        component: () => import("@/pages/paymentCenter/withdraw/withdrawOrdinary"),
        icon: "none",
        meta: {
            comName: "withdrawListOrdinary",
            needRefresh: true
        }
    },
    {
        path: "/paymentCenter/withdrawRecords",
        name: "提现审核",
        component: () => import("@/pages/paymentCenter/withdraw/withdrawRecords"),
        icon: "none",
        meta: {
            comName: "withdrawRecords",
            needRefresh: true
        }
    },
    {
        path: "/paymentCenter/withdrawRecordsCheck",
        name: "提现记录",
        component: () => import("@/pages/paymentCenter/withdraw/withdrawRecordsCheck"),
        icon: "none",
        meta: {
            comName: "withdrawRecordsCheck",
            needRefresh: true
        }
    },
];



// WEBPACK FOOTER //
// ./src/router/funds.js